/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createClientSubscription = /* GraphQL */ `
  mutation CreateClientSubscription(
    $input: CreateClientSubscriptionInput!
    $condition: ModelClientSubscriptionConditionInput
  ) {
    createClientSubscription(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateClientSubscription = /* GraphQL */ `
  mutation UpdateClientSubscription(
    $input: UpdateClientSubscriptionInput!
    $condition: ModelClientSubscriptionConditionInput
  ) {
    updateClientSubscription(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteClientSubscription = /* GraphQL */ `
  mutation DeleteClientSubscription(
    $input: DeleteClientSubscriptionInput!
    $condition: ModelClientSubscriptionConditionInput
  ) {
    deleteClientSubscription(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createPlatformSubscription = /* GraphQL */ `
  mutation CreatePlatformSubscription(
    $input: CreatePlatformSubscriptionInput!
    $condition: ModelPlatformSubscriptionConditionInput
  ) {
    createPlatformSubscription(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updatePlatformSubscription = /* GraphQL */ `
  mutation UpdatePlatformSubscription(
    $input: UpdatePlatformSubscriptionInput!
    $condition: ModelPlatformSubscriptionConditionInput
  ) {
    updatePlatformSubscription(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deletePlatformSubscription = /* GraphQL */ `
  mutation DeletePlatformSubscription(
    $input: DeletePlatformSubscriptionInput!
    $condition: ModelPlatformSubscriptionConditionInput
  ) {
    deletePlatformSubscription(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createPlatform = /* GraphQL */ `
  mutation CreatePlatform(
    $input: CreatePlatformInput!
    $condition: ModelPlatformConditionInput
  ) {
    createPlatform(input: $input, condition: $condition) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      owner
      clients {
        items {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        platformId
        email
        createdOn
        updatedOn
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
      }
      users {
        items {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const updatePlatform = /* GraphQL */ `
  mutation UpdatePlatform(
    $input: UpdatePlatformInput!
    $condition: ModelPlatformConditionInput
  ) {
    updatePlatform(input: $input, condition: $condition) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      owner
      clients {
        items {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        platformId
        email
        createdOn
        updatedOn
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
      }
      users {
        items {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const deletePlatform = /* GraphQL */ `
  mutation DeletePlatform(
    $input: DeletePlatformInput!
    $condition: ModelPlatformConditionInput
  ) {
    deletePlatform(input: $input, condition: $condition) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      owner
      clients {
        items {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        platformId
        email
        createdOn
        updatedOn
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
      }
      users {
        items {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const createClient = /* GraphQL */ `
  mutation CreateClient(
    $input: CreateClientInput!
    $condition: ModelClientConditionInput
  ) {
    createClient(input: $input, condition: $condition) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
      notifications {
        items {
          id
          clientId
          title
          message
          link
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        clientId
        identityId
        email
        webPushAlias
        webPushDescription
        webPushSubLink
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        webPushSubscribers {
          nextToken
        }
        webPushes {
          nextToken
        }
      }
      users {
        items {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushSubscribers {
        items {
          id
          clientId
          token
          type
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushes {
        items {
          id
          clientId
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      integrations {
        items {
          id
          integrationId
          clientId
          accessToken
          refreshToken
          dataKey
          insightJobPending
          allScopes
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateClient = /* GraphQL */ `
  mutation UpdateClient(
    $input: UpdateClientInput!
    $condition: ModelClientConditionInput
  ) {
    updateClient(input: $input, condition: $condition) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
      notifications {
        items {
          id
          clientId
          title
          message
          link
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        clientId
        identityId
        email
        webPushAlias
        webPushDescription
        webPushSubLink
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        webPushSubscribers {
          nextToken
        }
        webPushes {
          nextToken
        }
      }
      users {
        items {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushSubscribers {
        items {
          id
          clientId
          token
          type
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushes {
        items {
          id
          clientId
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      integrations {
        items {
          id
          integrationId
          clientId
          accessToken
          refreshToken
          dataKey
          insightJobPending
          allScopes
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteClient = /* GraphQL */ `
  mutation DeleteClient(
    $input: DeleteClientInput!
    $condition: ModelClientConditionInput
  ) {
    deleteClient(input: $input, condition: $condition) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
      notifications {
        items {
          id
          clientId
          title
          message
          link
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        clientId
        identityId
        email
        webPushAlias
        webPushDescription
        webPushSubLink
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        webPushSubscribers {
          nextToken
        }
        webPushes {
          nextToken
        }
      }
      users {
        items {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushSubscribers {
        items {
          id
          clientId
          token
          type
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushes {
        items {
          id
          clientId
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      integrations {
        items {
          id
          integrationId
          clientId
          accessToken
          refreshToken
          dataKey
          insightJobPending
          allScopes
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      clientId
      title
      message
      link
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      clientId
      title
      message
      link
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      clientId
      title
      message
      link
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
    }
  }
`;
export const createClientUser = /* GraphQL */ `
  mutation CreateClientUser(
    $input: CreateClientUserInput!
    $condition: ModelClientUserConditionInput
  ) {
    createClientUser(input: $input, condition: $condition) {
      id
      clientId
      identityId
      email
      webPushAlias
      webPushDescription
      webPushSubLink
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
      webPushSubscribers {
        items {
          id
          clientUserId
          token
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      webPushes {
        items {
          id
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const updateClientUser = /* GraphQL */ `
  mutation UpdateClientUser(
    $input: UpdateClientUserInput!
    $condition: ModelClientUserConditionInput
  ) {
    updateClientUser(input: $input, condition: $condition) {
      id
      clientId
      identityId
      email
      webPushAlias
      webPushDescription
      webPushSubLink
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
      webPushSubscribers {
        items {
          id
          clientUserId
          token
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      webPushes {
        items {
          id
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const deleteClientUser = /* GraphQL */ `
  mutation DeleteClientUser(
    $input: DeleteClientUserInput!
    $condition: ModelClientUserConditionInput
  ) {
    deleteClientUser(input: $input, condition: $condition) {
      id
      clientId
      identityId
      email
      webPushAlias
      webPushDescription
      webPushSubLink
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
      webPushSubscribers {
        items {
          id
          clientUserId
          token
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      webPushes {
        items {
          id
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const createWebPushSubscriber = /* GraphQL */ `
  mutation CreateWebPushSubscriber(
    $input: CreateWebPushSubscriberInput!
    $condition: ModelWebPushSubscriberConditionInput
  ) {
    createWebPushSubscriber(input: $input, condition: $condition) {
      id
      clientUserId
      token
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updateWebPushSubscriber = /* GraphQL */ `
  mutation UpdateWebPushSubscriber(
    $input: UpdateWebPushSubscriberInput!
    $condition: ModelWebPushSubscriberConditionInput
  ) {
    updateWebPushSubscriber(input: $input, condition: $condition) {
      id
      clientUserId
      token
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deleteWebPushSubscriber = /* GraphQL */ `
  mutation DeleteWebPushSubscriber(
    $input: DeleteWebPushSubscriberInput!
    $condition: ModelWebPushSubscriberConditionInput
  ) {
    deleteWebPushSubscriber(input: $input, condition: $condition) {
      id
      clientUserId
      token
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createWebPush = /* GraphQL */ `
  mutation CreateWebPush(
    $input: CreateWebPushInput!
    $condition: ModelWebPushConditionInput
  ) {
    createWebPush(input: $input, condition: $condition) {
      id
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updateWebPush = /* GraphQL */ `
  mutation UpdateWebPush(
    $input: UpdateWebPushInput!
    $condition: ModelWebPushConditionInput
  ) {
    updateWebPush(input: $input, condition: $condition) {
      id
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deleteWebPush = /* GraphQL */ `
  mutation DeleteWebPush(
    $input: DeleteWebPushInput!
    $condition: ModelWebPushConditionInput
  ) {
    deleteWebPush(input: $input, condition: $condition) {
      id
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createPluginPushSubscriber = /* GraphQL */ `
  mutation CreatePluginPushSubscriber(
    $input: CreatePluginPushSubscriberInput!
    $condition: ModelPluginPushSubscriberConditionInput
  ) {
    createPluginPushSubscriber(input: $input, condition: $condition) {
      id
      clientId
      token
      type
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updatePluginPushSubscriber = /* GraphQL */ `
  mutation UpdatePluginPushSubscriber(
    $input: UpdatePluginPushSubscriberInput!
    $condition: ModelPluginPushSubscriberConditionInput
  ) {
    updatePluginPushSubscriber(input: $input, condition: $condition) {
      id
      clientId
      token
      type
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deletePluginPushSubscriber = /* GraphQL */ `
  mutation DeletePluginPushSubscriber(
    $input: DeletePluginPushSubscriberInput!
    $condition: ModelPluginPushSubscriberConditionInput
  ) {
    deletePluginPushSubscriber(input: $input, condition: $condition) {
      id
      clientId
      token
      type
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createPluginPush = /* GraphQL */ `
  mutation CreatePluginPush(
    $input: CreatePluginPushInput!
    $condition: ModelPluginPushConditionInput
  ) {
    createPluginPush(input: $input, condition: $condition) {
      id
      clientId
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updatePluginPush = /* GraphQL */ `
  mutation UpdatePluginPush(
    $input: UpdatePluginPushInput!
    $condition: ModelPluginPushConditionInput
  ) {
    updatePluginPush(input: $input, condition: $condition) {
      id
      clientId
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deletePluginPush = /* GraphQL */ `
  mutation DeletePluginPush(
    $input: DeletePluginPushInput!
    $condition: ModelPluginPushConditionInput
  ) {
    deletePluginPush(input: $input, condition: $condition) {
      id
      clientId
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createPlatformUser = /* GraphQL */ `
  mutation CreatePlatformUser(
    $input: CreatePlatformUserInput!
    $condition: ModelPlatformUserConditionInput
  ) {
    createPlatformUser(input: $input, condition: $condition) {
      id
      platformId
      email
      createdOn
      updatedOn
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
    }
  }
`;
export const updatePlatformUser = /* GraphQL */ `
  mutation UpdatePlatformUser(
    $input: UpdatePlatformUserInput!
    $condition: ModelPlatformUserConditionInput
  ) {
    updatePlatformUser(input: $input, condition: $condition) {
      id
      platformId
      email
      createdOn
      updatedOn
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
    }
  }
`;
export const deletePlatformUser = /* GraphQL */ `
  mutation DeletePlatformUser(
    $input: DeletePlatformUserInput!
    $condition: ModelPlatformUserConditionInput
  ) {
    deletePlatformUser(input: $input, condition: $condition) {
      id
      platformId
      email
      createdOn
      updatedOn
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
    }
  }
`;
export const createEmPushyIntegration = /* GraphQL */ `
  mutation CreateEmPushyIntegration(
    $input: CreateEmPushyIntegrationInput!
    $condition: ModelEmPushyIntegrationConditionInput
  ) {
    createEmPushyIntegration(input: $input, condition: $condition) {
      id
      name
      logo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateEmPushyIntegration = /* GraphQL */ `
  mutation UpdateEmPushyIntegration(
    $input: UpdateEmPushyIntegrationInput!
    $condition: ModelEmPushyIntegrationConditionInput
  ) {
    updateEmPushyIntegration(input: $input, condition: $condition) {
      id
      name
      logo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteEmPushyIntegration = /* GraphQL */ `
  mutation DeleteEmPushyIntegration(
    $input: DeleteEmPushyIntegrationInput!
    $condition: ModelEmPushyIntegrationConditionInput
  ) {
    deleteEmPushyIntegration(input: $input, condition: $condition) {
      id
      name
      logo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createActiveIntegration = /* GraphQL */ `
  mutation CreateActiveIntegration(
    $input: CreateActiveIntegrationInput!
    $condition: ModelActiveIntegrationConditionInput
  ) {
    createActiveIntegration(input: $input, condition: $condition) {
      id
      integrationId
      clientId
      accessToken
      refreshToken
      dataKey
      insightJobPending
      allScopes
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      integration {
        id
        name
        logo
        createdAt
        updatedAt
        owner
      }
      owner
    }
  }
`;
export const updateActiveIntegration = /* GraphQL */ `
  mutation UpdateActiveIntegration(
    $input: UpdateActiveIntegrationInput!
    $condition: ModelActiveIntegrationConditionInput
  ) {
    updateActiveIntegration(input: $input, condition: $condition) {
      id
      integrationId
      clientId
      accessToken
      refreshToken
      dataKey
      insightJobPending
      allScopes
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      integration {
        id
        name
        logo
        createdAt
        updatedAt
        owner
      }
      owner
    }
  }
`;
export const deleteActiveIntegration = /* GraphQL */ `
  mutation DeleteActiveIntegration(
    $input: DeleteActiveIntegrationInput!
    $condition: ModelActiveIntegrationConditionInput
  ) {
    deleteActiveIntegration(input: $input, condition: $condition) {
      id
      integrationId
      clientId
      accessToken
      refreshToken
      dataKey
      insightJobPending
      allScopes
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      integration {
        id
        name
        logo
        createdAt
        updatedAt
        owner
      }
      owner
    }
  }
`;
export const createIntegrationOverview = /* GraphQL */ `
  mutation CreateIntegrationOverview(
    $input: CreateIntegrationOverviewInput!
    $condition: ModelIntegrationOverviewConditionInput
  ) {
    createIntegrationOverview(input: $input, condition: $condition) {
      id
      numCampaigns
      numSent
      avgSent
      avgDelivered
      avgBounce
      avgClick
      avgOpen
      wordFrequency
      prevOpened
      prevDelivered
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const updateIntegrationOverview = /* GraphQL */ `
  mutation UpdateIntegrationOverview(
    $input: UpdateIntegrationOverviewInput!
    $condition: ModelIntegrationOverviewConditionInput
  ) {
    updateIntegrationOverview(input: $input, condition: $condition) {
      id
      numCampaigns
      numSent
      avgSent
      avgDelivered
      avgBounce
      avgClick
      avgOpen
      wordFrequency
      prevOpened
      prevDelivered
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const deleteIntegrationOverview = /* GraphQL */ `
  mutation DeleteIntegrationOverview(
    $input: DeleteIntegrationOverviewInput!
    $condition: ModelIntegrationOverviewConditionInput
  ) {
    deleteIntegrationOverview(input: $input, condition: $condition) {
      id
      numCampaigns
      numSent
      avgSent
      avgDelivered
      avgBounce
      avgClick
      avgOpen
      wordFrequency
      prevOpened
      prevDelivered
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const createIntegrationABDelivery = /* GraphQL */ `
  mutation CreateIntegrationABDelivery(
    $input: CreateIntegrationABDeliveryInput!
    $condition: ModelIntegrationABDeliveryConditionInput
  ) {
    createIntegrationABDelivery(input: $input, condition: $condition) {
      id
      activeIntegrationId
      idVariantA
      idVariantB
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const updateIntegrationABDelivery = /* GraphQL */ `
  mutation UpdateIntegrationABDelivery(
    $input: UpdateIntegrationABDeliveryInput!
    $condition: ModelIntegrationABDeliveryConditionInput
  ) {
    updateIntegrationABDelivery(input: $input, condition: $condition) {
      id
      activeIntegrationId
      idVariantA
      idVariantB
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const deleteIntegrationABDelivery = /* GraphQL */ `
  mutation DeleteIntegrationABDelivery(
    $input: DeleteIntegrationABDeliveryInput!
    $condition: ModelIntegrationABDeliveryConditionInput
  ) {
    deleteIntegrationABDelivery(input: $input, condition: $condition) {
      id
      activeIntegrationId
      idVariantA
      idVariantB
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback(
    $input: CreateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    createFeedback(input: $input, condition: $condition) {
      id
      message
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback(
    $input: UpdateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    updateFeedback(input: $input, condition: $condition) {
      id
      message
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback(
    $input: DeleteFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    deleteFeedback(input: $input, condition: $condition) {
      id
      message
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createDashboardCard = /* GraphQL */ `
  mutation CreateDashboardCard(
    $input: CreateDashboardCardInput!
    $condition: ModelDashboardCardConditionInput
  ) {
    createDashboardCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updateDashboardCard = /* GraphQL */ `
  mutation UpdateDashboardCard(
    $input: UpdateDashboardCardInput!
    $condition: ModelDashboardCardConditionInput
  ) {
    updateDashboardCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deleteDashboardCard = /* GraphQL */ `
  mutation DeleteDashboardCard(
    $input: DeleteDashboardCardInput!
    $condition: ModelDashboardCardConditionInput
  ) {
    deleteDashboardCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createCallToActionCard = /* GraphQL */ `
  mutation CreateCallToActionCard(
    $input: CreateCallToActionCardInput!
    $condition: ModelCallToActionCardConditionInput
  ) {
    createCallToActionCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updateCallToActionCard = /* GraphQL */ `
  mutation UpdateCallToActionCard(
    $input: UpdateCallToActionCardInput!
    $condition: ModelCallToActionCardConditionInput
  ) {
    updateCallToActionCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deleteCallToActionCard = /* GraphQL */ `
  mutation DeleteCallToActionCard(
    $input: DeleteCallToActionCardInput!
    $condition: ModelCallToActionCardConditionInput
  ) {
    deleteCallToActionCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const createUrgencyCard = /* GraphQL */ `
  mutation CreateUrgencyCard(
    $input: CreateUrgencyCardInput!
    $condition: ModelUrgencyCardConditionInput
  ) {
    createUrgencyCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const updateUrgencyCard = /* GraphQL */ `
  mutation UpdateUrgencyCard(
    $input: UpdateUrgencyCardInput!
    $condition: ModelUrgencyCardConditionInput
  ) {
    updateUrgencyCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const deleteUrgencyCard = /* GraphQL */ `
  mutation DeleteUrgencyCard(
    $input: DeleteUrgencyCardInput!
    $condition: ModelUrgencyCardConditionInput
  ) {
    deleteUrgencyCard(input: $input, condition: $condition) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
